import { DeviceMgtListActions, DeviceMgtListActionTypes } from '../actions/device-mgt-list.actions';
import {DeviceMgtList} from '../device-mgt.model';

export interface DeviceMgtListState {
  Loaded: boolean;
  Loading: boolean;
  entities: DeviceMgtList[];
}

export const initialState: DeviceMgtListState = {
  Loaded: false,
  Loading: false,
  entities: []
};

export function reducer(state = initialState, action: DeviceMgtListActions): DeviceMgtListState {
  switch (action.type) {

    case DeviceMgtListActionTypes.GetDeviceMgtLists:
    return {...state, Loading: true, Loaded: false };

    case DeviceMgtListActionTypes.LoadDeviceMgtLists:
      return {...state, Loading: false, Loaded: true, entities: action.payload };

    case DeviceMgtListActionTypes.GetDeviceMgtListsFail:
      return {...state, Loading: false, Loaded: true};

    default:
      return state;
  }
}
